import { Link } from 'react-router-dom';
import { EmptyState } from '../components/EmptyState';

export function NotFoundPage() {
  return (
    <EmptyState icon="alert" title="Page not found">
      That page doesn't exist. <Link className="text-hs-primary font-semibold" to="/clients">Go to Your Family</Link>.
    </EmptyState>
  );
}
